module.exports = __webpack_public_path__ + "static/media/kerzen.2b4616e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kerzen.jpg
// module id = 112
// module chunks = 0